import { render, staticRenderFns } from "./NewCreditcard.vue?vue&type=template&id=1bc01660&"
import script from "./NewCreditcard.vue?vue&type=script&lang=ts&"
export * from "./NewCreditcard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports